import { Component, OnInit, Input } from '@angular/core';
import { DatePipe } from "@angular/common";

@Component({
    selector: 'delta-bubble',
    templateUrl: './delta-bubble.component.html',
    styleUrls: ['./delta-bubble.component.scss'],
    standalone: false
})
export class DeltaBubbleComponent implements OnInit {

    @Input() dateFormat: string = "MM/dd/yyyy";
    @Input() expectedDataType: string;
   
    @Input() originalValue: any;
    @Input() currentValue: any;

    @Input() domain: any[] = [];
    @Input() domainIdProperty: string;
    @Input() domainDisplayProperty: string;

    showInitialValue: boolean = false;

    get isChanged(): boolean {
        let changed: boolean = false;
        switch (this.expectedDataType) {
            case "Date":
                changed = this.initialValue !== this.datePipe.transform(this.currentValue, this.dateFormat);
                break;
            case "Number":
                changed = Number(this.originalValue) != Number(this.currentValue);
                break;
            case "Boolean":
                changed = Boolean(this.originalValue) != Boolean(this.currentValue);
                break;
            default:
                changed = this.originalValue != this.currentValue;
                break;
        }
        return changed;
    }

    get initialValue(): any {
        let returnValue: any;
        if (this.originalValue != null && this.originalValue !== "") {
            switch (this.expectedDataType) {
                case "Date":
                    returnValue = this.datePipe.transform(this.originalValue, this.dateFormat);
                    break;
                case "Number":
                    returnValue = Number(this.originalValue);
                    break;
                case "Domain":
                    returnValue = this.translateDomain(this.originalValue);
                    break;
                default:
                    returnValue = this.originalValue;
                    break;
            }
        } else {
            returnValue = "No value";
        }        

        return returnValue;
    }

    constructor(protected datePipe: DatePipe) { }

    ngOnInit() {
    }

    toggleShowChange(change: boolean): void {
        this.showInitialValue = change;
    }

    private translateDomain(toTranslate: any): any {
        if (this.domain == null || this.domain.length === 0) return "";
        let value = this.domain.find(d => d[this.domainIdProperty].toString() === toTranslate.toString());
        return value[this.domainDisplayProperty];
    }
}
